import { Store } from '.';
import { ArticleSearchResult, PageType } from '../../types';

export type PageSlice = {
  pageType: PageType;
  itemId?: string;
  itemType?: string;
  hasError: boolean;
  searchResults?: ArticleSearchResult;
  term?: string;
  setPageMeta: (meta: {
    itemId?: string;
    itemType?: string;
    hasError?: boolean;
    searchResults?: ArticleSearchResult;
    term?: string;
  }) => void;
};

export const getPageInitialState = (
  set: (stateUpdater: (state: Store) => Partial<Store>) => void
): PageSlice => ({
  pageType: PageType.Homepage,
  itemId: undefined,
  itemType: undefined,
  hasError: false,
  searchResults: undefined,
  term: undefined,
  setPageMeta: (meta) => {
    set((state) => ({
      pageSlice: {
        ...state.pageSlice,
        ...meta,
      },
    }));
  },
});
